import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { List, X, ArrowUpRight } from "@phosphor-icons/react";

const links = [
  { label: "About", id: "about" },
  { label: "Expertise", id: "expertise" },
  { label: "Patient Information", id: "journey" },
  { label: "FAQs", id: "faq" },
  { label: "Contact", id: "contact" },
];

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow,border-color] duration-500 ${
        scrolled ? "bg-white/85 backdrop-blur-xl border-b border-[#E6EBF0] shadow-[0_1px_30px_rgba(11,27,43,0.05)]" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 h-[76px] flex items-center justify-between">
        <button onClick={() => go("top")} data-testid="nav-logo" className="flex items-center gap-3 group">
          <span className="w-9 h-9 rounded-full bg-[#0A192F] text-white grid place-items-center font-display text-xl leading-none">R</span>
          <span className="text-left leading-tight">
            <span className="block font-display text-lg text-[#0A192F]">Dr. Sangeeta Roy</span>
            <span className="block label text-[0.55rem]">Pharmacology</span>
          </span>
        </button>

        <div className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`nav-${l.id}`}
              className="text-sm text-[#475569] hover:text-[#0A192F] transition-colors relative after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-[#0A192F] hover:after:w-full after:transition-all after:duration-300"
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={() => go("appointment")}
            data-testid="nav-book-cta"
            className="btn-accent hidden sm:inline-flex items-center gap-2 rounded-full pl-5 pr-4 py-2.5 text-sm font-semibold transition-[transform,background-color] duration-300"
          >
            Book / Enquire <ArrowUpRight size={16} weight="bold" />
          </button>
          <button onClick={() => setOpen(true)} data-testid="nav-hamburger" className="lg:hidden p-2 text-[#0A192F]" aria-label="Open menu">
            <List size={26} />
          </button>
        </div>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 z-[60] bg-[#0A192F] text-white lg:hidden"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            data-testid="mobile-menu"
          >
            <div className="flex items-center justify-between px-6 h-[76px] border-b border-white/10">
              <span className="font-display text-xl">Dr. Sangeeta Roy</span>
              <button onClick={() => setOpen(false)} data-testid="mobile-menu-close" aria-label="Close menu"><X size={26} /></button>
            </div>
            <div className="px-6 py-10 flex flex-col gap-2">
              {links.map((l, i) => (
                <motion.button
                  key={l.id}
                  onClick={() => go(l.id)}
                  initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.05 * i }}
                  className="text-left font-display text-4xl py-3 border-b border-white/10"
                >
                  {l.label}
                </motion.button>
              ))}
              <button onClick={() => go("appointment")} className="mt-8 rounded-full bg-white text-[#0A192F] py-4 text-base font-medium">
                Book an Appointment
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
